const FontFaceObserver = require("fontfaceobserver");

const loadFonts = () => {
  const link = document.createElement("link");
  link.href =
    "https://fonts.googleapis.com/css?family=Muli:200,300,400,400i,600,700,800";
  link.rel = "stylesheet";

  document.head.appendChild(link);

  const muli = new FontFaceObserver("Muli");

  muli.load().then(() => {
    document.documentElement.classList.add("muli");
  });
};

export default loadFonts;

export const getFontNameFromGoogleUrl = url => {
  const fontName = url
    .split("family=")
    .pop()
    .split(":")
    .shift()
    .split("+")
    .join(" ");
  return fontName;
};
